import { forwardRef, useEffect } from "react";
import {
  SortableList,
  SortableTemplate,
  Tooltip,
} from "@etframework/ui.components";
import useModalEvent from "../../hooks/useModalEvent";
import { useStages } from "../../data/queries/stageQueries";
import { useUpdateStageOrder } from "../../data/mutations/stageMutations";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export const StageListComponent = forwardRef(({ id }, ref) => {
  const { ModalEvents, toggleModal } = useModalEvent();
  const { mutate: updateStageOrder } = useUpdateStageOrder();
  const { t } = useTranslation(["Stages"]);

  const { boardId } = useParams();
  const { data: stages, isPending } = useStages(boardId);
  const disabledItems = stages
    ?.filter((stage) => stage?.Locked)
    ?.map((stage) => stage?.Id);

  const handleDragEnd = (args, orderedItems) => {
    const stagesIds = orderedItems.map((stage) => stage.id);
    updateStageOrder(
      { stages: { stagesIds: stagesIds } },
      {
        onSuccess: () => {},
        onError: () => {},
      }
    );
  };

  const onAddStage = (index) => {
    toggleModal(ModalEvents.CreateStageModal, {
      position: index + 1,
      ref,
    });
  };

  useEffect(() => {
    if (stages && ref?.current) {
      ref?.current?.setItems(
        stages?.map((stage) => {
          return {
            id: stage.Id,
            template: () => (
              <Tooltip
                content={() => {
                  return <span>{stage.Title}</span>;
                }}
                openDelay={500}
                position="TopCenter"
                showTipPointer={false}
              >
                <SortableTemplate
                  id={id + `_stage-type-${stage.StageType}-item`}
                  text={stage.Title}
                  colorIdentifier={stage?.Color}
                  disabled={stage.Locked}
                  onClick={() =>
                    toggleModal(ModalEvents.UpdateStageModal, { stage })
                  }
                />
              </Tooltip>
            ),
          };
        })
      );
    }
  }, [stages]);

  if (isPending) return null;

  return (
    <>
      <span className="drag-stages-title">{t("DragStages")}</span>
      <SortableList
        id={id}
        ref={ref}
        tooltipText={t("CreateStage")}
        onDragEnd={handleDragEnd}
        onAdd={onAddStage}
        disabledItems={disabledItems}
      />
    </>
  );
});
